<template>
  <div class="editOrder"
       v-loading.fullscreen.lock="fullscreenLoading">
    <!-- ===========智能填写弹框=========== -->
    <el-dialog title="智能填写"
               :visible.sync="smartInput"
               width="500px">
      <el-input type="textarea"
                :rows="7"
                placeholder="请将地址粘贴在此处"
                v-model="smartInput_text">
      </el-input>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click=" smartInput = false">取 消</el-button>
        <el-button type="primary"
                   @click="analysisSite">确 定</el-button>
      </span>
    </el-dialog>
    <template></template>
    <!-- =======地址库组件=======-->
    <address-book :site_list_show='site_list_show'
                  :recipients='recipients'
                  :stateId='orderData.addrid'
                  :isFba='isfba'
                  @submitpack='submitpack'>
    </address-book>

    <!-- =============主体内容============== -->
    <el-dialog title="选择修改的内容"
               :visible.sync="editShow"
               @open='getOrderData'
               width="500px">

      <div class="editView">
        <el-button type="primary"
                   @click="show_dialog">
          <i class="el-icon-user-solid"></i> 寄件人信息
        </el-button>
        <!-- <el-button type="primary"
                   v-if="orderData.type==2"
                   @click="show_recipients">
          <i class="el-icon-s-custom"></i> 收件人信息
        </el-button> -->
        <el-button type="primary"
                   @click="showGoodsInfo">
          <i class="el-icon-s-grid"></i> 物品信息
        </el-button>
        <el-button type="primary"
                   v-if="orderData.ofromtype==1"
                   @click="showKdnum"> <i class="el-icon-s-order"></i> 快递单号</el-button>
        <el-button type="primary"
                   v-if="orderData.ofromtype==2"
                   @click="showTime"> <i class="el-icon-timer"></i> 取件信息</el-button>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="editShow = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- =============修改寄件人信息============== -->
    <el-dialog title="修改寄件人信息"
               :visible.sync="editSender"
               width="900px">
      <div class="siteView">
        <div class="business_order_address">
          <div class="view_title">
            <div class="title_right">
              <el-link target="_blank"
                       @click="showAddressBook(1)"
                       :underline="false"> <i class="el-icon-notebook-1"></i> 地址簿</el-link>

              <el-link target="_blank"
                       :underline="false"
                       @click="smartInput=true"> <i class="el-icon-document-checked"></i> 智能填写</el-link>

            </div>
          </div>
          <el-form label-position="top"
                   label-width="80px"
                   :model="jj"
                   ref="jj"
                   class="jjForm">

            <el-form-item class="place_order_form_item"
                          prop="username"
                          :rules="[{required: true, message: '联系人姓名不能为空'}]"
                          label="姓名">
              <el-input v-model="jj.username"
                        placeholder="请填写联系人姓名"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="公司名称">
              <el-input v-model="jj.companyName"
                        placeholder="请填写公司名称"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="电话"
                          prop="mobile"
                          :rules="[{required: true, message: '联系电话不能为空'}]">
              <el-input v-model="jj.mobile"
                        placeholder="请填写联系电话"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="统编"
                          prop="companytaxid">
              <el-input v-model="jj.companytaxid"
                        placeholder="请输入统编"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          prop="site"
                          :rules="[{required: true, message: '省市区不能为空'}]"
                          label="省市区">
              <el-cascader v-model="jj.site"
                           placeholder="请选择您所在的地区"
                           :options="cnSite"></el-cascader>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="邮政编码">
              <el-input v-model="jj.zipcode"
                        placeholder="请填写联系电话"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item_max"
                          prop="address"
                          :rules="[{required: true, message: '详细地址不能为空'}]"
                          label="详细地址">
              <el-input v-model="jj.address"
                        placeholder="请填写所在街道以及详细地址"></el-input>
            </el-form-item>
          </el-form>
          <div class="saveSite">

            <el-link target="_blank"
                     @click="resetData(1)">重置</el-link>
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editSender = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmEdit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- ===========修改收件人(先不做)=========== -->
    <!-- <el-dialog title="修改收件人信息"
               v-if="orderData.type==2"
               :visible.sync="editRecipients"
               width="900px">
      <div class="siteView">
        <div class="borderView"></div>
        <div class="consignee_address">
          <div class="view_title">
            <div class="title_left">
            </div>
            <div class="title_right">
              <el-link target="_blank"
                       @click="showAddressBook(2)"
                       :underline="false"> <i class="el-icon-notebook-1"></i> 地址簿</el-link>
            </div>
          </div>
          <el-form label-position="top"
                   label-width="80px"
                   :model="sj"
                   ref="sj"
                   class="sjForm">

            <el-form-item class="place_order_form_item"
                          prop="username"
                          :rules="[{required: true, message: '联系人姓名不能为空'}]"
                          :label="sj.type!=3?'姓名':'仓库代码' ">
              <el-input v-model="sj.username"
                        placeholder="请填写联系人姓名"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="公司名称"
                          v-if="sj.type!=3">
              <el-input v-model="sj.companyname"
                        placeholder="请填写公司名称"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="电话"
                          v-if="sj.type!=3"
                          prop="mobile"
                          :rules="[{required: true, message: '联系电话不能为空'}]">
              <el-input v-model="sj.mobile"
                        placeholder="请填写联系电话"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="统编"
                          v-if="sj.type!=3"
                          prop="companytaxid">
              <el-input v-model="sj.companytaxid"
                        placeholder="请填写统编"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="仓库所在城市"
                          :rules="[{required: true, message: '省市区不能为空'}]"
                          v-if="sj.type==3"
                          prop="city">
              <el-input v-model="sj.city"
                        placeholder="请填写仓库所在城市"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          prop="site"
                          v-if="sj.type!=3"
                          :rules="[{required: true, message: '省市区不能为空'}]"
                          label="省市区">
              <el-cascader v-model="sj.site"
                           placeholder="请选择您所在的地区"
                           :options="active_site_data"></el-cascader>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          prop="zipcode"
                          :rules="[{required: true, message: '邮政编码不能为空'}]"
                          label="邮政编码">
              <el-input v-model="sj.zipcode"
                        placeholder="请填写联系电话"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item_max"
                          prop="address"
                          :rules="[{required: true, message: '详细地址不能为空'}]"
                          label="详细地址">
              <el-input v-model="sj.address"
                        placeholder="请填写所在街道以及详细地址">
              </el-input>
            </el-form-item>
          </el-form>
          <div class="saveSite">
            <el-link target="_blank"
                     @click="resetData(2)">重置</el-link>
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editRecipients = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmRecipients">确 定</el-button>
      </span>
    </el-dialog> -->

    <!-- =============修改物品信息============== -->
    <el-dialog title="修改包裹物品信息"
               :visible.sync="editGoodsInfo"
               class="editGoodsInfo"
               width="1000px">
      <packing-list :tableData='zxd_info'>

      </packing-list>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editGoodsInfo = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmEditGoods">确 定</el-button>
      </span>
    </el-dialog>

    <!-- =============修改快递单号============== -->
    <el-dialog title="修改快递单号"
               :visible.sync="editTrackingShow"
               class="editGoodsInfo"
               width="700px">
      <el-form :model="editTrackingNumber"
               ref="editTrackingNumber"
               label-width="100px">
        <el-form-item label="快递单号"
                      prop="value"
                      :rules="[
      { required: true, message: '快递单号不能为空'}
    ]">
          <el-input v-model="editTrackingNumber.value"
                    placeholder="请输入快递单号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editTrackingShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmEditTrackingNum">确 定</el-button>
      </span>
    </el-dialog>

    <!-- =============取件时间============== -->
    <el-dialog title="修改取件时间"
               :visible.sync="editTimeShow"
               class="editTimeShow"
               width="700px">
      <el-date-picker v-model="timeData"
                      type="date"
                      placeholder="选择日期"
                      :picker-options="pickerOptions">
      </el-date-picker>
      <div style="margin-top:20px">
        <el-input type="textarea"
                  :autosize='{ minRows: 2, maxRows: 4}'
                  placeholder="请输入取件备注内容"
                  v-model="remark">
        </el-input>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editTimeShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmQjInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AddressParse from 'address-parse';
import { apiZHCN, apiOrderDetails, } from '@/request/api'
import addressBook from '@/components/addressBook.vue'
import packingList from '@/components/packingList.vue'
export default {
  name: 'editOrder',
  data () {
    return {
      //--------日期配置--------
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '明天',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }]
      },
      //--------取件时间-------
      timeData: '',
      remark: '',
      //--------是否显示修改取件时间-------
      editTimeShow: false,
      //--------快递单数据--------
      editTrackingNumber: {
        value: ''
      },
      //--------是否显示修改快递单数据--------
      editTrackingShow: false,
      //--------装箱单数据--------
      zxd_info: [{
        wpinfo: []
      }],
      //--------是否显示物品信息--------
      editGoodsInfo: false,
      //--------地址数据--------
      active_site_data: [],
      //--------获取订单数据--------
      orderData: {},
      //--------地址数据--------
      smartInput_text: '',
      //--------是否显示智能填写--------
      smartInput: false,
      // ----------加载动画-----------
      fullscreenLoading: false,
      // ----------该国家是否支持fba-----------
      isfba: false,

      // ----------判断是否为寄件地址-----------
      recipients: 1,
      // ----------是否显示地址库数据-----------
      site_list_show: {
        flag: false
      },
      // -----------中国国家地区选择-----------
      cnSite: [],
      // ----------寄件信息-----------
      jj: {
        username: '',
        companyName: '',
        mobile: '',
        site: '',
        address: '',
        zipcode: '',
        companytaxid: '',
        save: true
      },
      sj: {
        username: '',
        companyName: '',
        mobile: '',
        site: '',
        address: '',
        zipcode: '',
        companytaxid: '',
        city: '',
        save: true
      },
      // ----------修改寄件人或者收件人----------
      deliveryType: '1',
      // ----------是否修改收件人信息----------
      editRecipients: false,
      // ----------是否修改寄件人信息----------
      editSender: false
    }
  },

  methods: {
    //   -----------修改取件信息-------
    confirmQjInfo () {
      this.$confirm('确定修改取件信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          timeData: this.timeData,
          remark: this.remark
        }
        this.editOrderData(5, data).then(() => {
          this.editTrackingShow = false
        })
      })


    },
    //   -----------修改快递单号-------
    confirmEditTrackingNum () {
      this.$refs.editTrackingNumber.validate((valid) => {
        if (valid) {
          this.$confirm('确定修改快递单号吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            console.log(this.editTrackingNumber.value);
            this.editOrderData(4, this.editTrackingNumber.value).then(() => {
              this.editTrackingShow = false
            })
          })
        } else {
          return false
        }
      })


    },
    //   -----------修改物品信息-------
    confirmEditGoods () {
      this.$confirm('确定修改包裹物品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = JSON.stringify(this.zxd_info)
        this.editOrderData(3, data).then(() => {
          this.editGoodsInfo = false
        })
      })
    },
    //   -----------确定修改收件人-------
    confirmRecipients () {
      this.$confirm('确定修改收件地址吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let sjren = ''
        let flag = false
        if (this.sj.type == 3) {
          sjren = this.sj.id
          flag = true
        } else {
          sjren = {
            'mobile': this.sj.mobile,
            'name': this.sj.username,
            'address': this.sj.address,
            'zipcode': this.sj.zipcode,
            'province': this.sj.site[0],
            'city': this.sj.site[1],
            'district': this.sj.site[2],
            'companyname': this.sj.companyName,
            'companytaxid': this.sj.companytaxid,
          }
          flag = false
        }

        this.editOrderData(2, JSON.stringify(sjren), flag).then(() => {
          this.editRecipients = false
        })
      })
    },
    //   -----------确定修改-------
    confirmEdit () {

      this.$confirm('确定修改寄件地址吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let jjren = {
          'mobile': this.jj.mobile,
          'name': this.jj.username,
          'address': this.jj.address,
          'zipcode': this.jj.zipcode,
          'province': this.jj.site[0],
          'city': this.jj.site[1],
          'district': this.jj.site[2],
          'companyname': this.jj.companyName,
          'companytaxid': this.jj.companytaxid,
        }
        this.editOrderData(1, JSON.stringify(jjren)).then(() => {
          this.editSender = false
        })
      })
    },
    //   -----------修改订单-------
    async editOrderData (type, data, flag) {
      console.log(data);
      this.fullscreenLoading = true
      let res = await apiOrderDetails({
        op: 'editpost',
        pd: "app_post",
        item: 'saveall',
        orderid: this.orderData.id,
        weight: 1,
        tj: 1,
        cdf: this.orderData.cdf,
        paytype: this.orderData.paytype,
        dsprice: this.orderData.dsprice,
        ygprice: this.orderData.ygprice,
        kdnum: type == 4 ? data : '',
        jjren: type == 1 ? data : '',
        sjren: type == 2 && !flag ? data : '',
        sjid: type == 2 && flag ? data : '',
        zxdinfo: type == 3 ? data : '',
        qjbzinfo: type == 5 ? data.remark : '',
        qjstartime: type == 5 ? data.timeData : ''
      })
      if (res.errno == 0) {
        this.$message.success('修改成功')
        this.getOrderData()
      } else {
        this.$message.error(res.message)
      }
      this.fullscreenLoading = false

    },
    //   -----------获取订单信息-------
    async getOrderData () {
      let res = await apiOrderDetails({
        op: 'orderinfo',
        pd: 'getinfo',
        orderid: this.orderId
      })
      if (res.addrid) {
        this.orderData = res
      } else {
        this.$message.error(res.message)
        this.$emit('change', false)
      }
    },
    //   -----------开始智能填写-------
    analysisSite () {
      let data = AddressParse.parse(this.smartInput_text)
      let details = data[0].details
      let reg = new RegExp('\市|\省|\行政区|\自治区', 'g')
      data = JSON.stringify(data[0])
      var a = JSON.parse(data.replace(reg, ""));
      a.details = details
      this.jj = {
        username: a.name,
        companyName: '',
        mobile: a.mobile,
        site: [a.province, a.city],
        address: a.details,
        zipcode: a.zip_code,
        save: true
      }
      if (a.area !== '') {
        this.jj.site.push(a.area)
      }
      this.$refs.jj.resetFields();

      this.smartInput = false
    },
    //   -----------获取中国数据-------
    async getCnData () {
      this.fullscreenLoading = true
      let res = await apiZHCN({
        all: 1,
      })
      this.cnSite = res.gjlist.CN.children
      this.fullscreenLoading = false
    },
    //   ----------重置数据格式-------
    resetData (type) {
      if (type == 2) {

        this.sj = {
          username: '',
          companyName: '',
          mobile: '',
          site: '',
          address: '',
          zipcode: '',
          companytaxid: '',
          save: true
        }
        this.$refs.sj.resetFields();
      } else {
        this.jj = {
          username: '',
          companyName: '',
          mobile: '',
          site: '',
          address: '',
          zipcode: '',
          save: true
        }
        this.$refs.jj.resetFields();

      }

    },
    // ----------- 选择了地址-----------
    submitpack (i, item) {
      console.log(item);
      if (this.recipients == 1) {
        this.jj = item
        this.jj.site = [this.jj.province, this.jj.city]
      } else {
        this.sj = item
        if (item.code) {
          this.sj.type = 3
          this.sj.username = item.code
        } else {
          this.sj.site = [this.sj.province, this.sj.city]
        }
      }
    },
    // ----------- 显示取件时间-----------
    showTime () {
      this.timeData = this.orderData.qjstartime
      this.remark = this.orderData.qjbzinfo
      this.editTimeShow = true
    },
    // ----------- 显示快递单号-----------
    showKdnum () {
      this.editTrackingNumber.value = this.orderData.kdnum
      this.editTrackingShow = true
    },
    // ----------- 显示物品信息-----------
    showGoodsInfo () {
      console.log(this.orderData);
      this.zxd_info = this.orderData.xz_weight_tj
      this.editGoodsInfo = true
    },
    // ----------- 显示地址簿-----------
    showAddressBook (type) {
      this.recipients = type
      this.site_list_show.flag = true
    },
    // -----------是否显示修改收件人信息-----------
    show_recipients () {

      this.sj = {
        city: this.orderData.sjcity,
        username: this.orderData.sjname,
        companyName: this.orderData.sjcompanyname,
        mobile: this.orderData.sjmobile,
        site: [this.orderData.sjprovince, this.orderData.sjcity],
        address: this.orderData.sjaddress,
        zipcode: this.orderData.sjzipcode,
        save: true,
      }
      if (this.orderData.sjcompanyname == 'FBA') {
        this.sj.type = 3
      }
      this.getActiveData()
      this.editRecipients = true
    },
    // -----------是否显示修改寄件人信息-----------
    show_dialog () {
      this.jj = {
        username: this.orderData.jjname,
        companyName: this.orderData.jjcompanyname,
        mobile: this.orderData.jjmobile,
        site: [this.orderData.jjprovince, this.orderData.jjcity],
        address: this.orderData.jjaddress,
        zipcode: this.orderData.jjzipcode,
        save: true,
      }
      this.editSender = true
    }
  },

  computed: {
    //  计算属性-是否显示
    editShow: {
      get: function () {
        return this.show
      },
      set: function (flag) {
        this.$emit('change', flag)
      }
    },
  },
  components: {
    addressBook,
    packingList
  },
  props: {
    //   需要修改的订单id
    orderId: {
      type: [String, Number],
      require: true,

    },
    //   外部控制是否显示变量
    show: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  created () {
    this.getCnData()
  }
}
</script>

<style lang='scss'>
.editOrder {
  .editGoodsInfo {
    .packingList_module_view {
      width: 90%;
    }
  }
  .editView {
    display: flex;
    justify-content: center;
    flex-direction: column;
    .el-button {
      margin-left: 0 !important;
      margin-bottom: 10px;
    }
  }
  //   ---------地址库---------
  .siteView {
    width: 100%;
    display: flex;
    height: 450px;
    justify-content: space-between;
    .business_order_address,
    .consignee_address {
      width: 100%;
      display: flex;
      flex-direction: column;
      .saveSite {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        .el-checkbox__inner {
          border-radius: 50%;
        }
        .el-link {
          margin-left: 20px;
        }
      }
      .view_title {
        display: flex;
        font-size: 16px;
        color: #333;
        justify-content: flex-end;
        .title_right {
          .el-link {
            margin-left: 30px;
          }
        }
      }
      .el-form {
        box-sizing: border-box;
        width: 100%;
        // padding-left: 50px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .el-form-item__label {
          padding: 0;
          height: 30px;
        }
        .el-input__inner {
          border-top: 0;
          border-left: 0;
          border-radius: 0;
          border-right: 0;
          padding-left: 0;
        }
        .el-form-item {
          //   margin-bottom: 10px;
        }
        .place_order_form_item_max {
          width: 100%;
          .el-cascader {
            width: 100%;
          }
        }
        .place_order_form_item {
          width: 40%;
          .el-cascader {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>